import { Chatroom } from '../../models';
import { useState } from 'react';

export const enum QuickActions {
  DELETE = 'delete',
  CLOSE = 'close',
}

type State = {
  isOpen: boolean;
  action: QuickActions | null | undefined;
  room: Chatroom | null | undefined;
};

type ToggleFunction = (
  display: boolean,
  action?: QuickActions,
  room?: Chatroom
) => void;

export function useOpenQuickActionConfirmModal(): [State, ToggleFunction] {
  const [state, setState] = useState<State>({
    isOpen: false,
    action: null,
    room: undefined,
  });

  const toggle = (isOpen: boolean, action?: QuickActions, room?: Chatroom) => {
    setState({ isOpen, action, room });
  };

  return [state, toggle];
}
